var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWeiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221.603,
    height: 50.412,
    viewBox: "0 0 221.603 50.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_81",
    "data-name": "Rechteck 81",
    width: 221.603,
    height: 50.412,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_113",
    "data-name": "Gruppe 113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_112",
    "data-name": "Gruppe 112",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M68.556,37.3H66.017V26.164c0-2.678-1.58-3.912-3.479-3.912-2.639,0-4.085,2.776-4.085,4.012V37.3h-2.5V26.164c0-2.678-1.566-3.912-3.464-3.912-2.653,0-4.085,2.776-4.085,4.012V37.3H45.86V21.08h2.269l.136,2.406a5.593,5.593,0,0,1,5.32-3.134,4.518,4.518,0,0,1,4.647,3.307,5.662,5.662,0,0,1,5.441-3.307c2.946,0,4.883,1.764,4.883,5.244Z",
    transform: "translate(12.898 5.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M82.426,37.3c-.1-.838-.1-1.431-.2-2.332a6.285,6.285,0,0,1-5.32,2.7c-2.81,0-4.809-1.6-4.809-4.416,0-3.937,4.106-5.517,8.757-5.677l1.3-.037V25.869c0-1.716-.9-3.677-3.368-3.677a6.113,6.113,0,0,0-4.513,2l-1.074-1.6a7.368,7.368,0,0,1,5.686-2.234c3.775,0,5.748,2,5.748,5.776v8.86A17.511,17.511,0,0,0,84.8,37.3Zm-.27-8.021-1.3.037c-3.652.1-6.191,1.332-6.191,3.874,0,1.37.938,2.641,3.207,2.641,1.714,0,4.281-1.567,4.281-3.147Z",
    transform: "translate(20.278 5.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M95.464,40.592c0,4.208-1.842,5.614-4.752,5.614a5.408,5.408,0,0,1-2.466-.568l.9-1.876a3.269,3.269,0,0,0,1.64.469c1.567,0,2.135-1.234,2.135-3.64V22.6h2.545Zm-1.275-22.3a1.672,1.672,0,0,1,0-3.344,1.672,1.672,0,0,1,0,3.344",
    transform: "translate(24.818 4.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M116.18,29.336H105.192c0,4.418,2.208,6.454,4.908,6.454,2.479,0,3.613-1.431,4.513-2.431l1.074,1.628a6.909,6.909,0,0,1-5.586,2.678c-5.476,0-7.509-4.109-7.509-8.785,0-4.146,1.972-8.528,6.916-8.528s6.673,3.641,6.673,7.689Zm-2.4-1.8c0-3.208-1.431-5.343-4.268-5.343-2.675,0-4.315,2.641-4.315,5.343Z",
    transform: "translate(28.853 5.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M126.637,37.665c-3.775,0-5.28-1.567-6.056-2.542l1.64-1.431a5.345,5.345,0,0,0,4.416,2.1c2.666,0,3.675-1.468,3.675-2.7,0-1.7-1.008-2.407-2.715-2.949l-2.439-.8c-1.863-.63-3.936-1.667-3.936-4.479s3.033-4.5,5.882-4.5a6.428,6.428,0,0,1,5.477,2.542l-1.676,1.3a4.4,4.4,0,0,0-3.8-2c-2.142,0-3.341,1.1-3.341,2.666,0,1.5,1.47,2.01,2.7,2.442l2.247.766c2.4.814,4.167,1.949,4.167,5.022,0,2-1.566,4.578-6.24,4.578",
    transform: "translate(33.913 5.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M146.707,38.253a8.3,8.3,0,0,1-2.579.469c-3.107,0-4.438-1.209-4.438-4.652V23.95H137.15V22.136h2.539V18.064L142.23,16.6v5.54H146V23.95H142.23v9.725c0,1.876.3,3.171,2.133,3.171a3.98,3.98,0,0,0,1.937-.53Z",
    transform: "translate(38.573 4.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M165.308,20.921,158.994,38.6c-1.505,4.146-2.741,5.923-5.354,5.923A6.322,6.322,0,0,1,151,43.96l.843-1.8a3.955,3.955,0,0,0,1.8.469c1.444,0,2.208-1.74,2.971-4.023l.372-1.1-6.375-16.586h2.937l4.747,13.746,4.282-13.746Z",
    transform: "translate(42.357 5.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M22.3,33.259,11.15,26.8,0,33.259V0H22.3Z",
    transform: "translate(0 0)",
    fill: "#9ed4d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M39.7,33.259,28.554,26.8,17.4,33.259V0H39.7Z",
    transform: "translate(4.895 0)",
    fill: "#019199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M171.314,20.862a2.981,2.981,0,0,1-2.946-3,2.934,2.934,0,0,1,2.946-2.925,2.9,2.9,0,0,1,2.937,2.925,2.974,2.974,0,0,1-2.937,3m0-5.4a2.363,2.363,0,0,0-2.331,2.406,2.332,2.332,0,1,0,4.652,0,2.361,2.361,0,0,0-2.322-2.406M172.67,19.6h-.615l-.68-1.037c-.21-.333-.393-.506-.542-.506h-.183V19.6h-.519V16.186h1.27a.961.961,0,0,1,1.061.938c0,.592-.454.826-.939.9a1.556,1.556,0,0,1,.359.395Zm-1.379-2.987h-.642v1.024h.406c.689,0,.885-.172.885-.518s-.292-.506-.65-.506",
    transform: "translate(47.353 4.202)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWeiss);
export default __webpack_public_path__ + "static/media/logo_weiss.69b86105f6671c0ed313e4a7aa3db31c.svg";
export { ForwardRef as ReactComponent };